import React from 'react';

import { GoogleAnalyticsConstants } from '@vvoyages/google-analytics';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './PredefinedButtons.module.scss';
import Button from '../Button';
import CloseIcon from '../Icon/CloseIcon';

export const CloseButtonVariants = {
  DEFAULT: 'default',
  WHITE: 'white',
};

type CloseButtonProps = {
  className: string;
  onClick: () => void;
  variant: string;
};

const CloseButton = ({ className, onClick, variant }: CloseButtonProps) => {
  const iconClasses = classnames({
    [styles.greyFill]: variant === CloseButtonVariants.WHITE,
  });
  const classes = classnames(styles.circle, className, {
    [styles.transparentBackground]: variant === CloseButtonVariants.DEFAULT,
    [styles.whiteBackground]: variant === CloseButtonVariants.WHITE,
  });
  return (
    <Button
      className={classes}
      onClick={onClick}
      aria-label="Close"
      trackAction={GoogleAnalyticsConstants.EVENT_ACTION.ICON_CLICK}
      trackLabel="close"
    >
      <CloseIcon className={iconClasses} />
    </Button>
  );
};

CloseButton.propTypes = {
  variant: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default CloseButton;
